module.exports = "/subscriptions/assets/a03662c3cbc08763d6899ebb947dc4a1.png";